import { baseConfig } from '../base.config';
import { mix } from '@oec-seller/sdk/m4b-seller-material';

export const REGION_CONFIG = mix(baseConfig, {} as Partial<typeof baseConfig>);
